export class SpecialParams {
  hideLeftCabin: boolean;
  hideRightCabin: boolean;
}
